import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'

Vue.use(Vuex)

const store = new Vuex.Store({

  state: () => ({
     loading: 0,
      cancelTokenArr: []
  }),
  getters: {
      loading: state => state.loading > 0
  },
  mutations: {
      setLoading(state, value) {
          state.loading += value
      },
      pushToken (state, payload) {
          state.cancelTokenArr.push(payload.cancelToken)
      },
      clearToken ({ cancelTokenArr }) {
          cancelTokenArr.forEach(item => {
              item('Solicitud de cancelación de salto de ruta')
          })
          cancelTokenArr = []
      }
  },
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',
})

export default store
